import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { IMailSettings } from '../interfaces';
import { SettingsMapper } from '../mappers';

export type IGetMailSettingsRepoResponse = IRepoResponse<200, IMailSettings> | IRepoResponse<400 | 500, string>;

export type IGetMailSettingsRepo = IRepo<[number | string], IGetMailSettingsRepoResponse>;

export const GetMailSettingsRepoType = Symbol.for('GetMailSettingsRepo');

@bind(GetMailSettingsRepoType)
export class GetMailSettingsRepo implements IGetMailSettingsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/settings/data', { group_id: 'email' }) });
      if (result.status === 200) {
        const data: any = SettingsMapper.mailSettingsToDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
